export const Theme = {
    primary: "#014BAE"
}